var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        ref: "drawer",
        staticClass:
          "drawer drawer-right drawer-messages dw-xs-10 dw-sm-6 dw-md-6 fold",
        attrs: {
          id: "drawer-messages-chat",
          "aria-labelledby": "drawer-messages-chat",
        },
      },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.closeDrawer,
                expression: "closeDrawer",
              },
            ],
            staticClass: "drawer-contents",
          },
          [
            _c("div", { staticClass: "drawer-main" }, [
              _c("div", { staticClass: "drawer-heading" }, [
                _c("h3", { staticClass: "drawer-title" }, [
                  _vm._v("\n            Messages\n            "),
                  _c(
                    "a",
                    {
                      ref: "closeButton",
                      staticClass: "btn btn-default pull-right",
                      attrs: {
                        href: "#drawer-messages-chat",
                        "data-toggle": "drawer",
                        "aria-foldedopen": "true",
                        "aria-controls": "drawer-messages-chat",
                      },
                      on: { click: _vm.handleCloseThreadCallback },
                    },
                    [_c("i", { staticClass: "fa fa-close" })]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "drawer-body" },
                [_c("thread-discussion")],
                1
              ),
              _vm._v(" "),
              _vm.userHasAcceptedTerms || this.$userIsAdmin || _vm.adminThread
                ? _c("div", { staticClass: "drawer-footer row" }, [
                    _c("form", [
                      _c("div", { staticClass: "textarea-container" }, [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.messageText,
                              expression: "messageText",
                            },
                          ],
                          ref: "messageText",
                          staticClass: "form-control m-b-xs",
                          attrs: {
                            name: "message text field",
                            type: "text",
                            placeholder: "Type message here...",
                            disabled:
                              !_vm.thread ||
                              !_vm.thread.active ||
                              (!_vm.userHasAcceptedTerms &&
                                !this.$userIsAdmin &&
                                !_vm.adminThread),
                          },
                          domProps: { value: _vm.messageText },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) return
                                _vm.messageText = $event.target.value
                              },
                              function ($event) {
                                return _vm.$emit(
                                  "input",
                                  $event.target.messageText
                                )
                              },
                            ],
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.handleEnterKeyPress.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticStyle: { color: "#a94442" } }, [
                          _vm._v(
                            _vm._s(_vm.errors.first("message text field"))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "button-container" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-sm btn-info circle-btn inactive",
                            attrs: {
                              disabled:
                                !_vm.thread ||
                                !_vm.thread.active ||
                                (!_vm.userHasAcceptedTerms &&
                                  !this.$userIsAdmin &&
                                  !_vm.adminThread) ||
                                _vm.messageSending,
                              type: "button",
                            },
                            on: { click: _vm.handleSendMessageCallback },
                          },
                          [
                            _c("i", { staticClass: "fa fa-send" }),
                            _vm._v(" \n                "),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-sm btn-info circle-btn inactive",
                            attrs: {
                              disabled:
                                !_vm.thread ||
                                !_vm.thread.active ||
                                (!_vm.userHasAcceptedTerms &&
                                  !this.$userIsAdmin &&
                                  !_vm.adminThread) ||
                                _vm.messageSending,
                              type: "button",
                            },
                            on: { click: _vm.handleGetFileInputChat },
                          },
                          [
                            _c("i", { staticClass: "fa fa-2x fa-paperclip" }),
                            _vm._v(" \n                  "),
                            _c("input", {
                              ref: "fileInputChat",
                              staticStyle: { display: "none" },
                              attrs: { type: "file", multiple: "" },
                              on: { change: this.handleAddBookingFiles },
                            }),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.typers.length > 1
                      ? _c("div", { staticClass: "col-xs-12" }, [
                          _c(
                            "p",
                            [
                              _vm._l(_vm.typers, function (typer, index) {
                                return _c("span", { key: typer.id }, [
                                  _vm._v(
                                    "\n                " + _vm._s(typer.name)
                                  ),
                                  index < _vm.typers.length - 1
                                    ? _c("span", [_vm._v(" and ")])
                                    : _vm._e(),
                                ])
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "\n                are typing\n              "
                                ),
                              ]),
                            ],
                            2
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.typers.length === 1
                      ? _c(
                          "div",
                          { staticClass: "col-xs-12" },
                          _vm._l(_vm.typers, function (typer) {
                            return _c("p", { key: typer.id }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(typer.name) +
                                  " is typing\n            "
                              ),
                            ])
                          }),
                          0
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "drawer-sidebar hidden-xs" },
              [
                _c("thread-sidebar", {
                  attrs: { booking_id: this.thread.booking.id },
                }),
              ],
              1
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }